import * as ng from 'angular';
import { UISelectService } from '../../../../services/ui-select.service';
import { ArchiSmallServices } from '../../../../services/archismall.service';
import { ArchiSmallERRORS } from '../../../../commons/errors';

class ConservazioneCaricaDocumentoModello730Step2Controller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: {
      saveAnagrafica: () => Promise<boolean>
      [key:string]: any
    },
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {
    $scope.pageHeader = 'Carica Documento';
    $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

    if (store.get('conservazioneClasseDocumentale') === null) {
      $state.go('home.conservazione-carica-documento-step1');
      return;
    }

    $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

    $scope.years = [];
    const curr_year = new Date().getFullYear();
    for (let i = curr_year - 1; i <= curr_year; i++) {
      $scope.years.push(i);
    }
    const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {anno: number, scadenza: string}[];
    if (years) {
      for (let year of years) {
        if (new Date(year.scadenza) > new Date()) {
          $scope.years.push(year.anno);
        }
      }
    }

    $scope.anagraficaDestinatarioIsNew = true;
    $scope.anagraficaSostitutoImpostaIsNew = true;

    //$scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
    //$scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    $scope.destinatario = {};
    $scope.sostitutoimposta = {};
    $scope.PIVAType = new RegExp('(^[0-9]{11}$)|ND');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{16}$');
    let isNomeDestinatarioDisabled;
    let isCognomeDestinatarioDisabled;
    let isRagioneSocialeDestinatarioDisabled;
    let isDestinatarioCFDisabled;
    let isDestinatarioPIVADisabled;
    let isNomeSostitutoImpostaDisabled;
    let isCognomeSostitutoImpostaDisabled;
    let isRagioneSocialeSostitutoImpostaDisabled;
    let isSostitutoImpostaCFDisabled;
    let isSostitutoImpostaPIVADisabled;

    $scope.prev = () => {
      $scope.setConservazioneSettings();
      $state.go('home.conservazione-carica-documento-step1', { 'classeDocumentale': $scope.classeDocumentale });
    };

    $scope.saveAnagrafica = async () => {
      let anagraficaDestinatario = {
        email_pec: '',
        emails: [],
        nome: $scope.settings.destinatarioNome,
        cognome: $scope.settings.destinatarioCognome,
        company_name: $scope.settings.destinatarioRagioneSociale,
        fiscal_code: $scope.settings.destinatarioCodiceFiscale,
        piva: $scope.settings.destinatarioPiva,
        type: $scope.settings.destinatarioRagioneSociale !== '' ? 2 : `${$scope.settings.destinatarioNome} ${$scope.settings.destinatarioCognome}`.trim() !== '' ? 1 : 2
      };
      let anagraficaSostitutoImposta = {
        email_pec: '',
        emails: [],
        nome: $scope.settings.sostitutoimpostaNome,
        cognome: $scope.settings.sostitutoimpostaCognome,
        company_name: $scope.settings.sostitutoimpostaRagioneSociale,
        fiscal_code: $scope.settings.sostitutoimpostaCodiceFiscale,
        piva: $scope.settings.sostitutoimpostaPiva,
        type: $scope.settings.sostitutoimpostaRagioneSociale !== '' ? 2 : `${$scope.settings.sostitutoimpostaNome} ${$scope.settings.sostitutoimpostaCognome}`.trim() !== '' ? 1 : 2
      };
      const anagrafiche = [];
      if ($scope.anagraficaDestinatarioIsNew) {
        anagrafiche.push(anagraficaDestinatario);
      }
      if ($scope.anagraficaSostitutoImpostaIsNew) {
        anagrafiche.push(anagraficaSostitutoImposta);
      }
      const results = [];
      for(const anagrafica of anagrafiche){
        try{
          await ArchiSmallServices.insertAnagrafica(anagrafica);
          results.push(true);
        }catch(err){
          if (err.errorCode !== ArchiSmallERRORS.DUPLICATE_KEY) {
            $rootScope.alert('error', err);
          }
          results.push(false);
        }
      }
      return new Promise((resolve,reject)=>{
        if (results.every(v=>v) || results.length==0){
          resolve(true);
        }
        reject(false);
      });
    };

    $rootScope.formsubmitted = false;

    // <editor-fold desc='setConservazioneSettings'>
    $scope.setConservazioneSettings = () => {
      $scope.settings.destinatarioRagioneSociale = $scope.destinatario.anagrafica;

      $scope.settings.sostitutoimpostaRagioneSociale = $scope.sostitutoimposta.anagrafica;

      let classeDocumentale = $scope.settings.classeDocumentale.key;

      let userSettings = {
        'key': classeDocumentale,
        'value': $scope.settings
      };

      ArchiSmallServices.setConservazioneSettings(userSettings)
        .then((response: any) => {
          // ??
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    // <editor-fold desc='getConservazioneSettings'>
    $scope.getConservazioneSettings = () => {
      $rootScope.readyToUse = false;
      $scope.currentClasseDocumentale = $scope.classeDocumentale;
      ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
        .then((response: any) => {
          if (response !== undefined && response !== '') {
            $scope.settings = response.value;
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;

            $scope.destinatario.anagrafica = $scope.settings.destinatarioRagioneSociale;
            isNomeDestinatarioDisabled = $scope.settings.destinatarioNome !== '' && $scope.settings.destinatarioNome !== undefined;
            isCognomeDestinatarioDisabled = $scope.settings.destinatarioCognome !== '' && $scope.settings.destinatarioCognome !== undefined;
            isRagioneSocialeDestinatarioDisabled = $scope.settings.destinatarioRagioneSociale !== '' && $scope.settings.destinatarioRagioneSociale !== undefined;
            isDestinatarioCFDisabled = $scope.settings.destinatarioCodiceFiscale !== '' && $scope.settings.destinatarioCodiceFiscale !== undefined;
            isDestinatarioPIVADisabled = $scope.settings.destinatarioPiva !== '' && $scope.settings.destinatarioPiva !== undefined;

            $scope.sostitutoimposta.anagrafica = $scope.settings.sostitutoimpostaRagioneSociale;
            isNomeSostitutoImpostaDisabled = $scope.settings.sostitutoimpostaNome !== '' && $scope.settings.sostitutoimpostaNome !== undefined;
            isCognomeSostitutoImpostaDisabled = $scope.settings.sostitutoimpostaCognome !== '' && $scope.settings.sostitutoimpostaCognome !== undefined;
            isRagioneSocialeSostitutoImpostaDisabled = $scope.settings.sostitutoimpostaRagioneSociale !== '' && $scope.settings.sostitutoimpostaRagioneSociale !== undefined;
            isSostitutoImpostaCFDisabled = $scope.settings.sostitutoimpostaCodiceFiscale !== '' && $scope.settings.sostitutoimpostaCodiceFiscale !== undefined;
            isSostitutoImpostaPIVADisabled = $scope.settings.sostitutoimpostaPiva !== '' && $scope.settings.sostitutoimpostaPiva !== undefined;

          } else {
            $scope.settings = $scope.getSettingsDefault();
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          }
          $rootScope.readyToUse = true;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    if ($scope.classeDocumentale !== '') {
      $scope.getConservazioneSettings();
    }

    $scope.getAnagraficaTypeaheadValues = () => {
      ArchiSmallServices.getAnagraficaTypeaheadValues()
        .then((response: any) => {
          $scope.anagrafica = response;

        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getAnagraficaTypeaheadValues();

    $scope.autocompleteFields = (item, tipo: string) => {
      if (item !== undefined && typeof item === 'object') {
        if (tipo === 'destinatario') {
          if (item.piva === undefined) {
            $scope.settings.destinatarioNome = '';
            $scope.settings.destinatarioCognome = '';
            $scope.settings.destinatarioRagioneSociale = '';
            $scope.settings.destinatarioPiva = '';
            $scope.settings.destinatarioCodiceFiscale = '';
            isNomeDestinatarioDisabled = false;
            isCognomeDestinatarioDisabled = false;
            isRagioneSocialeDestinatarioDisabled = false;
            isDestinatarioCFDisabled = false;
            isDestinatarioPIVADisabled = false;
            $scope.anagraficaDestinatarioIsNew = true;
          } else {
            $scope.settings.destinatarioNome = item.nome;
            $scope.settings.destinatarioCognome = item.cognome;
            $scope.settings.destinatarioRagioneSociale = item.company_name;
            $scope.settings.destinatarioPiva = item.piva;
            $scope.settings.destinatarioCodiceFiscale = item.fiscal_code;
            isNomeDestinatarioDisabled = item.nome !== '' && item.nome !== undefined;
            isCognomeDestinatarioDisabled = item.cognome !== '' && item.cognome !== undefined;
            isRagioneSocialeDestinatarioDisabled = item.company_name !== '' && item.company_name !== undefined;
            isDestinatarioCFDisabled = item.fiscal_code !== '' && item.fiscal_code !== undefined;
            isDestinatarioPIVADisabled = item.piva !== '' && item.piva !== undefined;
            $scope.anagraficaDestinatarioIsNew = false;
          }
        }
        if (tipo === 'sostitutoimposta') {
          if (item.piva === undefined) {
            $scope.settings.sostitutoimpostaNome = '';
            $scope.settings.sostitutoimpostaCognome = '';
            $scope.settings.sostitutoimpostaRagioneSociale = '';
            $scope.settings.sostitutoimpostaPiva = '';
            $scope.settings.sostitutoimpostaCodiceFiscale = '';
            isNomeSostitutoImpostaDisabled = false;
            isCognomeSostitutoImpostaDisabled = false;
            isRagioneSocialeSostitutoImpostaDisabled = false;
            isSostitutoImpostaCFDisabled = false;
            isSostitutoImpostaPIVADisabled = false;
            $scope.anagraficaSostitutoImpostaIsNew = true;
          } else {
            $scope.settings.sostitutoimpostaNome = item.nome;
            $scope.settings.sostitutoimpostaCognome = item.cognome;
            $scope.settings.sostitutoimpostaRagioneSociale = item.company_name;
            $scope.settings.sostitutoimpostaPiva = item.piva;
            $scope.settings.sostitutoimpostaCodiceFiscale = item.fiscal_code;
            isNomeSostitutoImpostaDisabled = item.nome !== '' && item.nome !== undefined;
            isCognomeSostitutoImpostaDisabled = item.cognome !== '' && item.cognome !== undefined;
            isRagioneSocialeSostitutoImpostaDisabled = item.company_name !== '' && item.company_name !== undefined;
            isSostitutoImpostaCFDisabled = item.fiscal_code !== '' && item.fiscal_code !== undefined;
            isSostitutoImpostaPIVADisabled = item.piva !== '' && item.piva !== undefined;
            $scope.anagraficaSostitutoImpostaIsNew = false;
          }
        }
      }
    };

    $scope.clear = ($event, $select) => {
      UISelectService.clear($event, $select);

      if ($select.ngModel.$name === 'destinatario') {
        $scope.destinatario.anagrafica = '';
        $scope.settings.destinatarioNome = '';
        $scope.settings.destinatarioCognome = '';
        $scope.settings.destinatarioRagioneSociale = '';
        $scope.settings.destinatarioPiva = '';
        $scope.settings.destinatarioCodiceFiscale = '';
        isDestinatarioCFDisabled = false;
        isDestinatarioPIVADisabled = false;
        $scope.anagraficaDestinatarioIsNew = false;
      }
      if ($select.ngModel.$name === 'sostitutoimposta') {
        $scope.sostitutoimposta.anagrafica = '';
        $scope.settings.sostitutoimpostaNome = '';
        $scope.settings.sostitutoimpostaCognome = '';
        $scope.settings.sostitutoimpostaRagioneSociale = '';
        $scope.settings.sostitutoimpostaPiva = '';
        $scope.settings.sostitutoimpostaCodiceFiscale = '';
        isSostitutoImpostaCFDisabled = false;
        isSostitutoImpostaPIVADisabled = false;
        $scope.anagraficaSostitutoImpostaIsNew = false;
      }
    };

    $scope.isNomeDestinatarioDisabled = () => {
      return isNomeDestinatarioDisabled;
    };
    $scope.isCognomeDestinatarioDisabled = () => {
      return isCognomeDestinatarioDisabled;
    };
    $scope.isRagioneSocialeDestinatarioDisabled = () => {
      return isRagioneSocialeDestinatarioDisabled;
    };
    $scope.isDestinatarioCFDisabled = () => {
      return isDestinatarioCFDisabled;
    };
    $scope.isDestinatarioPIVADisabled = () => {
      return isDestinatarioPIVADisabled;
    };

    $scope.isNomeSostitutoImpostaDisabled = () => {
      return isNomeSostitutoImpostaDisabled;
    };
    $scope.isCognomeSostitutoImpostaDisabled = () => {
      return isCognomeSostitutoImpostaDisabled;
    };
    $scope.isRagioneSocialeSostitutoImpostaDisabled = () => {
      return isRagioneSocialeSostitutoImpostaDisabled;
    };
    $scope.isSostitutoImpostaCFDisabled = () => {
      return isSostitutoImpostaCFDisabled;
    };
    $scope.isSostitutoImpostaPIVADisabled = () => {
      return isSostitutoImpostaPIVADisabled;
    };

    /* tslint:enable:no-string-literal */
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    // <editor-fold desc='openModello730Modal'>
    $scope.openModello730Modal = async (size) => {

      try{
        await $scope.saveAnagrafica();
      }catch(err){
        return;
      }

      $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');

      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'workerModello730ModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return $scope.settings;
          }
        }
      });
    };
    // </editor-fold>

  }
}

export const ConservazioneCaricaDocumentoModello730Step2Component: ng.IComponentOptions = {
    template: require('./conservazione-carica-documento-modello-730-step2.html'),
    controller: ConservazioneCaricaDocumentoModello730Step2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-modello-730-step2/conservazione-carica-documento-modello-730-step2.ts